export default __webpack_public_path__ + "static/media/leaf_outline@3x.fabd485d.png";